import { ValidationError } from './validation-error';

export class ValidationErrors {
  public BusinessValidationErrors: Array<ValidationError>;
  public FullValidationErrors: Array<ValidationError>;

  constructor(validationErrors: any) {
    if (validationErrors) {
      const { BusinessValidationErrors: businessValidationErrors, FullValidationErrors: fullValidationErrors } =
        validationErrors;

      this.BusinessValidationErrors = ValidationErrors.processValidationErrors(businessValidationErrors);
      this.FullValidationErrors = ValidationErrors.processValidationErrors(fullValidationErrors);
    }
  }

  static processValidationErrors(validationErrors: any): Array<ValidationError> {
    const result: Array<ValidationError> = [];
    Object.keys(validationErrors).forEach((validationErrorKey) => {
      const validationError = new ValidationError();
      validationError.key = validationErrorKey;
      const validationData = validationErrors[validationErrorKey];
      const json = JSON.parse(validationData);
      Object.assign(validationError, json);
      result.push(validationError);
    });

    return result;
  }
}
